import React from "react";
import Card from "../card/Card";
import { useFetchgetHomeQuery } from "../../store/api/ProductSlice";
import { FiArrowRight } from "react-icons/fi";

function PopularProduct() {
  const { data, isLoading } = useFetchgetHomeQuery();

  console.log("These are the products", data);

  return (
    <div
      id="discount"
      className="mx-auto max-w-screen-2xl bg-gray-50 px-3 py-6 sm:px-10 lg:py-6"
    >
      {/* Section Heading */}
      <div className="mb-6 flex w-full items-center justify-between">
        <h2 className="flex items-center gap-[9px] font-serif text-[20px] font-bold leading-none tracking-[-0.5px] text-[#17151b] sm:text-[22px]">
          <span className="h-[14px] w-[2px] rounded-full bg-[#7027df]" />
          Popular Products
        </h2>

        <a
          href="/shop"
          className="flex shrink-0 items-center gap-[5px] text-[10px] font-semibold text-[#6b28d9] transition-colors hover:text-[#4818a8] sm:text-xs"
        >
          View All
          <FiArrowRight size={14} />
        </a>
      </div>

      {/* Products Grid */}
      <div className="flex">
        <div className="w-full">
          <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 md:gap-3 lg:grid-cols-5 lg:gap-3 2xl:grid-cols-6">
            {!isLoading &&
              data?.slice(-5).map((product) => (
                <Card key={product._id} data={product} />
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PopularProduct;